export default __webpack_public_path__ + "static/media/budget.3856eabf.png";